// extracted by mini-css-extract-plugin
export var dropdown = "_v3-0";
export var imageWrapper = "_v3-3";
export var itemNameContainer = "_v3-1";
export var productImage = "_v3-2";
export var spinnerWrapper = "_v3-4";